import script from "./PersonalRole.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalRole.vue?vue&type=script&setup=true&lang=js"

import "./PersonalRole.vue?vue&type=style&index=0&id=f0d3ae72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0d3ae72"]])

export default __exports__